import { PureComponent } from 'react';

import history from 'Util/History';

import MenuqItem from './MenuqItem.component';
import { HOVER_TIMEOUT } from './MenuqItem.config';

const scrollToTop = (options = {}) => window.scrollTo({ ...options, top: 0 });

export class MenuqItemContainer extends PureComponent {
    static defaultProps = {
        onCategoryHover: () => {},
        itemMods: {},
        isLink: false,
        isExpandable: false
    };

    containerFunctions = {
        handleCategoryHover: this.handleCategoryHover.bind(this),
        handleLinkLeave: this.handleLinkLeave.bind(this),
        onItemClick: this.onItemClick.bind(this)
    };

    menuHoverTimeout = null;

    containerProps() {
        const {
            activeMenuItemsStack,
            isExpandable,
            isLink,
            item,
            itemMods
        } = this.props;

        return {
            activeMenuItemsStack,
            isExpandable,
            isLink,
            item,
            itemMods
        };
    }

    onItemClick() {
        const { activeMenuItemsStack } = this.props;
        scrollToTop();

        // keep the stack here, so later we can deconstruct menu out of it
        const { pathname } = location;
        history.push(pathname, { stack: activeMenuItemsStack });
    }

    handleCategoryHover() {
        const { onCategoryHover, item, activeMenuItemsStack } = this.props;

        const hoverTimeOut = activeMenuItemsStack.length === 0 ? HOVER_TIMEOUT : 0;

        this.menuHoverTimeout = setTimeout(() => {
            onCategoryHover(item);
        }, hoverTimeOut);
    }

    handleLinkLeave() {
        clearTimeout(this.menuHoverTimeout);
    }

    render() {
        return (
            <MenuqItem
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default MenuqItemContainer;
